import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { type PropType, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import type { Locale } from 'vue-i18n';

import LocalTime from '@exchange/libs/components/history/LocalTime.vue';
import usePromise from '@exchange/libs/composables/shared/src/lib/usePromise';
import { modalVariant, type ModalVariant } from '@exchange/libs/modals/src';

type TermsMode = 'acknowledge' | 'accept' | 'accept-and-remind-me-later';


const __default__ = {
  name: 'TermsAndConditionsModal',
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  accept: { type: Function as PropType<() => Promise<void>>, required: true },
  effectiveDate: { type: String, required: false },
  html: { type: Object as PropType<Record<Locale, string>>, required: false },
  mode: { type: String as PropType<TermsMode>, default: 'acknowledge' },
  remindMeLater: { type: Function as PropType<() => Promise<void>>, required: false },
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.dark },
},
  setup(__props) {

const { locale } = useI18n();

const props = __props;

const { loading: accepting, createPromise: accept } = usePromise(props.accept);

const effectiveDate = computed(() => (props.effectiveDate ? new Date(props.effectiveDate) : undefined));

return (_ctx: any,_cache: any) => {
  const _component_x_link_external = _resolveComponent("x-link-external")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_x_button = _resolveComponent("x-button")!
  const _component_x_modal = _resolveComponent("x-modal")!

  return (_openBlock(), _createBlock(_component_x_modal, {
    class: "terms-and-conditions-modal",
    "can-close": false,
    wide: true,
    variant: __props.variant,
    title: _ctx.$t('ui.termsAndConditions.title')
  }, {
    content: _withCtx(() => [
      (__props.html)
        ? (_openBlock(), _createElementBlock("div", {
            key: _unref(locale),
            class: "terms-and-conditions-modal__content-html",
            innerHTML: __props.html[_unref(locale)]
          }, null, 8, _hoisted_1))
        : (_openBlock(), _createBlock(_component_i18n_t, {
            key: 1,
            keypath: "ui.termsAndConditions.disclaimer",
            class: "terms-and-conditions-modal__content",
            scope: "global",
            tag: "p"
          }, {
            linkTermsAndConditions: _withCtx(() => [
              _createVNode(_component_x_link_external, {
                href: _ctx.$t('ui.termsAndConditions.disclaimerLinks.linkTermsAndConditions.link'),
                "use-system-browser": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('ui.termsAndConditions.disclaimerLinks.linkTermsAndConditions.text')), 1)
                ]),
                _: 1
              }, 8, ["href"])
            ]),
            termsEffectiveDate: _withCtx(() => [
              (effectiveDate.value)
                ? (_openBlock(), _createBlock(LocalTime, {
                    key: 0,
                    time: effectiveDate.value,
                    format: "d MMMM yyyy"
                  }, null, 8, ["time"]))
                : _createCommentVNode("", true)
            ]),
            linkCustomerCare: _withCtx(() => [
              _createVNode(_component_x_link_external, {
                href: _ctx.$t('ui.termsAndConditions.disclaimerLinks.linkSupport.link'),
                "use-system-browser": true
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('ui.termsAndConditions.disclaimerLinks.linkSupport.text')), 1)
                ]),
                _: 1
              }, 8, ["href"])
            ]),
            _: 1
          }))
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_x_button, {
        variant: "primary",
        loading: _unref(accepting),
        disabled: _unref(accepting),
        onClick: _unref(accept)
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(__props.mode === 'acknowledge' ? _ctx.$t('fundamentals.ok') : _ctx.$t('fundamentals.accept')), 1)
        ]),
        _: 1
      }, 8, ["loading", "disabled", "onClick"]),
      (__props.mode === 'accept-and-remind-me-later')
        ? (_openBlock(), _createBlock(_component_x_button, {
            key: 0,
            variant: "outline",
            onClick: __props.remindMeLater
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('ui.termsAndConditions.remindMeLater')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["variant", "title"]))
}
}

})